import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { ITheme } from "../../../utils/theme";
import { IMessage } from "../DRPluginAvailabilityData";

export interface INotEleigibleMessageProps {
  messages: IMessage[]
}

export const NotEleigibleMessage: FC<INotEleigibleMessageProps> = ({ messages }) => (
  <Box sx={{ py: 6, px: 1 }}>
    {
      messages.map(m => <Typography sx={{ mb: 2, color: (theme: ITheme) => theme.palette.black }} key={m.messageCode}>
        {m.messageText}
      </Typography>)
    }
  </Box>
)